module.exports = {
    BASE_URL: 'https://cms.partexstar.com/wp-json/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
